import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import UIEnglishActivity from './english-activity-list'
import UIEnglishActivityDetails from './english-activity-details'
import UIEnglishActivityModify from './english-activity-modify'
import UIEnglishActivityParticipates from './english-activity-participates'

export default class EnglishActivity extends Component {
    render() {
        return (
            <Switch>
                <Route path='/learnpoints/activity' component={UIEnglishActivity} exact /> {/*exact = 路徑完全匹配*/}
                <Route path='/learnpoints/activity/details' component={UIEnglishActivityDetails} />
                <Route path='/learnpoints/activity/modify' component={UIEnglishActivityModify} />
                <Route path='/learnpoints/activity/participates' component={UIEnglishActivityParticipates} />
                <Redirect to='/learnpoints/activity' />
            </Switch>
        )
    }
} 